import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { Context } from '../../../../context/AppContext';

const ProfileLink = ({ children, url, anchor, ...props }) => {
  const {
    media: { desktop, tablet },
  } = useContext(Context);
  return desktop || tablet ? (
    <a href={`${url}${anchor || ''}`} {...props} target="_blank">
      {children}
    </a>
  ) : (
    <Link to={`${url}${anchor || ''}`} {...props}>
      {children}
    </Link>
  );
};

export default ProfileLink;
